import { z } from "zod";

import { ScoringMethodEnum } from "@examspark/types";

export const ApiV1ExamConfigsSchema = z.object({
  examConfigs: z.array(
    z.object({
      id: z.string(),
      maturity: z.string(),
      name: z.string(),
      examId: z.string(),
      createdAt: z.string(),
      updatedAt: z.string(),
    }),
  ),
});

export const ApiV1ExamConfigSchema = z.object({
  allowSaveAndExit: z.boolean(),
  allowRetakes: z.boolean(),
  enableCalculatorType: z.enum(["NONE", "BASIC", "SCIENTIFIC", "GRAPHING"]),
  enableHighlighter: z.boolean(),
  enableLineReader: z.boolean(),
  enableLiveProctor: z.boolean(),
  enableOptionEliminator: z.boolean(),
  enableReadAloud: z.boolean(),
  showCorrectAnswersOnComplete: z.boolean(),
  showScoreOnComplete: z.boolean(),
  shuffleOptions: z.boolean(),
  shuffleItems: z.boolean(),
  attemptResolutionStrategy: z.object({
    mode: z.enum(["LATEST", "HIGHEST"]),
  }),
  scoringMethod: z
    .enum([ScoringMethodEnum.CustomLimitedPartialCredit])
    .describe(
      `[EXPERIMENTAL] The scoring method to use for the entire exam. Overrides a similarly-named \
      property at the \`item\` level. Use this control with caution.`,
    ),
});

export type ApiV1ExamConfig = z.infer<typeof ApiV1ExamConfigsSchema>;

export const ApiV1PutExamConfigRequestSchema = z.object({
  config: ApiV1ExamConfigSchema.partial().strict(),
  alignmentIds: z.array(z.string()).optional(),
});
